<template>
  <div v-if="component && component.properties" :class="['report-column-edit-combobox', column.lineWrap && 'report-column-edit-column-normal']" ref="control">
    <div :style="{'height': column.lineWrap && controlHeight}" v-if="edit && !component.properties.readonly && !component.properties.hidden" class="select">
      <el-select v-model="currentValue"
                 ref="input"
                 :placeholder="component.properties.placeholder||'请选择'"
                 :multiple="component.properties.multiple"
                 :filterable="component.properties.search"
                 :title="getShowCurrentValue()"
                 :class="{'multiple-combobox': component.properties.multiple, 'error-border': error}"
                 :automatic-dropdown="true"
                 no-data-text="无匹配数据"
                 @change="changComboboxValue"
                 @focus="setOptionsWidth"
                 @visible-change="visableChange">
        <span v-if="component.properties.multiple" slot="prefix">
          <template v-if="component.properties.search">
            <span :style="{width: getSpanWidth}" v-show="getShowCurrentValue() !== ''" class="show-name">{{ getShowCurrentValue() }}</span>
          <el-input ref="rcComboboxMultipeInput" :class="[getShowCurrentValue() !== '' && 'clearPadding']" :style="{width: `${parentWidth - parseFloat(getSpanWidth)}px`}" v-model="keywords" :placeholder="getShowCurrentValue() !== '' ? '' : '请选择'" @focus.stop="openOptions" @blur="clearKeywords"></el-input>
          </template>
          <template v-else>
            <span class="no-search">{{getShowCurrentValue()}}</span>
          </template>
        </span>
      <el-option
        v-for="(item, index) in showOptions"
        :title="item.value"
        :key="index"
        :label="item.value"
        :value="item.id">
      </el-option>
    </el-select>
    </div>
    <template v-else>
      <template v-if="component.properties.readonly || component.properties.hidden">
        <el-tooltip v-if="showTooltip && !column.lineWrap" effect="dark" :content="formatter(getShowCurrentValue(true))" placement="top">
          <div class="span" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm" :style="{'line-height': !column.lineWrap && controlHeight}" v-html="formatter(getShowCurrentValue(true))"></div>
        </el-tooltip>
        <div v-else class="span">
          <div class="span" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm" :style="{'line-height': !column.lineWrap && controlHeight}" v-html="formatter(getShowCurrentValue(true))"></div>
        </div>
      </template>
      <template v-else>
        <el-tooltip v-if="showTooltip && !column.lineWrap" :enterable="false" effect="dark" :content="formatter(getShowCurrentValue(true))" placement="top">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}">
            <span :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm" v-html="formatter(getShowCurrentValue(true))"></span>
            <i class="el-icon-arrow-down" @click.stop="openInput"></i>
          </div>
        </el-tooltip>
        <div v-else class="span" :style="{'line-height': !column.lineWrap && controlHeight}">
          <span :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm" v-html="formatter(getShowCurrentValue(true))"></span>
          <i class="el-icon-arrow-down" @click.stop="openInput"></i>
        </div>
      </template>
    </template>
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script>
import publicMixin from './mixin'
export default {
  name: 'report-rc-combobox',
  mixins: [publicMixin],
  props: ['comboboxDataSource'],
  data () {
    return {
      loading: false,
      options: [],
      currentValue: '',
      isRequest: false,
      keywords: '',
      parentWidth: '',
      showOptions: [],
      canOpen: true,
      combobxValue: '',
      close: false,
      initProperties: false
    }
  },
  methods: {
    visableChange (val) {
      if (!val) {
        if (!this.error) {
          this.edit = false
          this.close = false
        }
      }
    },
    async initOptions () {
      if (this.component.properties.dataSource && this.component.properties.dataSource.enable) {
        // 提高效率，防止每一个数据源下拉框都走一遍接口
        let item = this.comboboxDataSource.find(c => c.id === this.component.properties.dataSource.reportId)
        if (!item) {
          await this.loadDataSourceOptions()
        } else {
          if (item.loading) {
            this.options = item.value
          }
        }
      } else {
        await this.loadTemplateOptions()
      }
    },
    changComboboxValue (value) {
      this.error = ''
      if (this.component.properties.multiple && this.component.properties.search) {
        this.$refs.rcComboboxMultipeInput.focus()
      }
      // 多选下拉需要校验必填
      if (this.component.properties.multiple && this.component.properties.required) {
        if (!value || value.length === 0) {
          this.error = `${this.component.name}不能为空`
          return false
        }
      }
      // 数据源下拉框
      if (this.component.properties.dataSource && this.component.properties.dataSource.enable) {
        // 数据源下拉框修改值需要将 双归档的值都修改
        if (value === null || value === undefined) {
          // 修改下拉框的值
          this.combobxUpdateValue([{id: this.column.id, value: ''}, {id: this.editColumn.combobxColumnId, value: ''}])
        } else {
          let val = ''
          if (this.component.properties.multiple) {
            val = this.options.filter(c => value.includes(c.id)).map(m => m.value).join(', ')
          } else {
            val = this.options.find(c => c.id === value).value
          }
          // 修改下拉框的值
          this.combobxUpdateValue([{id: this.column.id, value: val}, {id: this.editColumn.combobxColumnId, value: this.component.properties.multiple ? value.join(', ') : value}])
        }
        this.$nextTick(() => this.getValue())
      } else {
        if (value === null || value === undefined) {
          this.update('')
        } else {
          this.update(this.component.properties.multiple ? value.join(', ') : value)
        }
        this.$nextTick(() => this.getValue())
      }
    },
    getValue () {
      if (this.component && this.component.properties) {
        // 如果是数据源下拉框
        if (this.component.properties.dataSource && this.component.properties.dataSource.enable) {
          this.getDataSorceCombobxValue()
        } else {
          if (this.component.properties.multiple) {
            if (this.value) {
              this.currentValue = this.value.split(', ')
            } else if (typeof this.value === 'string') {
              this.currentValue = []
            }
          } else {
            if (this.value || typeof this.value === 'string') {
              this.currentValue = this.value
            }
          }
        }
      }
    },
    getDataSorceCombobxValue () {
      if (this.component.properties.dataSource && this.component.properties.dataSource.enable) {
        this.combobxValue = this.value
        let value = this.data[this.editColumn.combobxColumnId]
        if (this.component.properties.multiple) {
          if (value) {
            this.currentValue = value.split(', ')
          } else {
            this.currentValue = []
          }
        } else {
          if (value || typeof value === 'string') {
            let item = null
            if (this.options && this.options.length) {
              item = this.options.find(c => c.id === value)
            }
            this.currentValue = !item ? this.value : value
          }
        }
      }
    },
    setOptionsWidth () {
      let doc = document.querySelectorAll('.el-select-dropdown')
      doc.length && doc.forEach(e => {
        e.style.width = this.$refs.control.offsetWidth + 'px'
      })
    },
    getStrLength (str) {
      let width = 0
      if (str) {
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 255) {
            width += 12
          } else {
            width += str.charCodeAt(i) === 32 ? 3 : 6
          }
        }
      }
      return width
    },
    openOptions () {
      setTimeout(() => {
        if (this.$refs.input && !this.$refs.input.$data.visible) {
          this.$refs.input.$data.visible = true
        }
      }, 300)
    },
    clearKeywords () {
      setTimeout(() => {
        if (this.keywords && this.keywords.trim() !== '') {
          if (!this.$refs.input.$data.visible) {
            this.canOpen = false
            this.keywords = ''
          }
        }
      }, 200)
    },
    loadDataSourceOptions () {
      this.options = []
      let dataSource = this.component.properties.dataSource
      this.$emit('setDataSource', {id: dataSource.reportId, loading: false, value: ''})
      let params = {'index': -1, 'size': -1}
      let columnId = dataSource.columnId
      let showColumnId = dataSource.showColumnId
      params.filters = dataSource.filter
      dataSource.filter && Object.keys(dataSource.filter).forEach(m => {
        if (!dataSource.filter[m].match(/\$\{(.*?)\}/)) {
          params.filters[m] = dataSource.filter[m]
        }
      })
      this.$axios.get(`/report-api/report/data/${dataSource.reportId}`, {params: params}).then((res) => {
        let options = []
        res.data.forEach(m => {
          options.push({id: m[columnId], value: m[showColumnId]})
        })
        this.options = options
        this.$emit('setDataSource', {id: dataSource.reportId, loading: true, value: options})
      })
    },
    loadTemplateOptions () {
      this.options = []
      this.component.properties.template.stringOptions.trim().split('\n').forEach(m => {
        this.options.push({id: m, value: m})
      })
    },
    combobxUpdateValue (datas) {
      datas.forEach(d => this.$emit('updateColumn', d, this.data))
      this.$nextTick(async () => {
        await this.saveData()
        // 保证修改完值之后再触发监听
        datas.forEach(d => this.$set(this.copyData, d.id, d.value))
      })
    }
  },
  watch: {
    keywords (val) {
      if (this.canOpen) {
        this.openOptions()
      } else {
        this.canOpen = true
      }
      this.showOptions = []
      this.$nextTick(() => {
        this.showOptions = this.options.filter(item => item.value.includes(val))
      })
    },
    initProperties: {
      // 可能因为这个值是在深度监听中修改的，所以这边需要使用深度监听才能监听到这个值的改变。。
      async handler (val) {
        if (val && this.component && this.component.properties && typeof this.component.properties === 'object') {
          this.initOptions()
        }
      },
      deep: true,
      immediate: true
    },
    options: {
      // 这个也是。。
      async handler (val) {
        this.showOptions = [...val]
        // 需要加载完options在加载value
        await this.getValue()
      },
      deep: true,
      immediate: true
    },
    value () {
      this.getValue()
    },
    width (val) {
      this.parentWidth = val
    },
    comboboxDataSource: {
      handler (val) {
        if (this.component && this.component.properties && this.component.properties.dataSource && this.component.properties.dataSource.enable) {
          let item = val.find(c => c.id === this.component.properties.dataSource.reportId && c.loading)
          if (item) {
            this.options = item.value
          }
        }
      },
      deep: true
    },
    data: {
      handler (val) {
        if (this.error) {
          this.edit = false
        }
        this.value = val[this.column.id]
        this.error = ''
        this.getShowTooltip()
        this.getValue()
      },
      deep: true
    },
    edit (val) {
      if (!val) this.keywords = ''
    }
  },
  computed: {
    getShowCurrentValue () {
      return label => {
        if (this.component) {
          let value = []
          let properties = typeof this.component.properties === 'object' ? this.component.properties : JSON.parse(this.component.properties)
          if (properties && properties.dataSource) {
            if (label) {
              if (properties.dataSource && properties.dataSource.enable) {
                return this.value
              }
            }
            let currentValue = label && properties.dataSource && properties.dataSource.enable ? this.combobxValue : this.currentValue
            if (!properties.multiple) {
              return currentValue
            }
            if (currentValue) {
              if (!(currentValue instanceof Array)) {
                let item = this.options.find(n => n.id === currentValue)
                item && value.push(item.value)
              } else {
                currentValue.forEach(c => {
                  let item = this.options.find(n => n.id === c)
                  item && value.push(item.value)
                })
              }
            }
            return value.join(', ')
          } else {
            return ''
          }
        } else {
          return ''
        }
      }
    },
    getSpanWidth () {
      let width = 0
      if (this.parentWidth) {
        // 最大宽度为60%
        let maxWidth = this.parentWidth * 0.7
        if (this.getShowCurrentValue() && this.getShowCurrentValue().length) {
          let strWidth = this.getStrLength(this.getShowCurrentValue())
          width = strWidth >= maxWidth ? maxWidth : strWidth
        }
      }
      return `${width}px`
    }
  },
  mounted () {
    let dom = this.$refs.control
    this.parentWidth = dom ? dom.offsetWidth : ''
  }
}
</script>

<style lang="scss">
  .report-column-edit-combobox {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    .span {
      font-size: 13px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 20px;
      height: 100%;
      // 报表中有下拉框时，多标签页进入line-height为0导致文本上移
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 13px;
      }
      .el-icon-arrow-down {
        position: absolute;
        right: 3px;
        top: calc(50% - 7px);
        cursor: pointer;
        color: #C2C3C4;
        display: none;
        &:hover {
          color: #55acf1;
        }
        &:active {
          color: #3079df;
        }
      }
      &:hover {
        .el-icon-arrow-down {
          display: inline-block;
        }
      }
    }
    .select {
      width: 100%;
      height: 100%;
      .el-select, .el-input {
        // .pagination-list .el-main .content .el-input 覆盖了
        width: 100% !important;
        height: 100%;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
        .el-input__inner {
          width: 100%;
          // .pagination-list .el-main .content .el-input .el-input__inner 这个样式覆盖了
          height: 100% !important;
          -webkit-border-radius: 0;
          -moz-border-radius: 0;
          border-radius: 0;
          font-size: 13px;
          color: #000;
          text-align: center;
        }
        .el-input__suffix {
          display: none;
        }
        .el-select__tags {
          max-width: none !important;
        }
      }
      .multiple-combobox {
        .el-select__tags {
          display: none;
        }
        .el-input--prefix {
          .el-input__prefix {
            color: #363636;
            width: calc(100% - 3px);
            left: 2px;
            span {
              width: 100%;
              height: 42px;
              line-height: 42px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .show-name {
                font-size: 13px;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
              }
              .el-input {
                border: none;
                height: 40px;
                line-height: 40px;
                width: 100%;
                .el-input__inner {
                  border: none;
                  height: 30px !important;
                  line-height: 30px;
                  padding-left: 0;
                  text-align: left;
                }
                .el-input__suffix {
                  width: 0;
                }
              }
              .clearPadding {
                .el-input__inner {
                  padding-right: 0;
                }
              }
              .no-search {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
                font-size: 13px;
                display: inline-block;
              }
            }
          }
        }
      }
      .error-border {
        & > .el-input--suffix {
          & > .el-input__inner {
            border: 1px solid #F05459;
          }
        }
      }
    }
    .error-message {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 2;
      background-color: #FEECEC;
      color: #F05459;
      border: 1px solid #F05459;
      padding: 0 5px;
      border-top: none;
      text-align: left;
      font-size: 12px;
    }
  }
  .report-column-edit-column-normal {
    position: relative;
    .span{
      white-space: normal;
      line-height: 26px;
      padding: 5px 25px 5px 5px;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/reportColumnEdit/rc-combobox.vue